"use client";
import Cookies from "js-cookie";

export type CookieOptions = {
  path?: string;
  secure?: boolean;
  sameSite?: "strict" | "lax" | "none";
  maxAge?: number; // in seconds
};

export function getClientCookie(name: string): string | undefined {
  return Cookies.get(name);
}

export function setClientCookie(
  name: string,
  value: string,
  options?: CookieOptions
) {
  const cookieOptions: Cookies.CookieAttributes = {
    path: options?.path || "/",
    secure: options?.secure,
    sameSite: options?.sameSite,
  };

  if (options?.maxAge) {
    cookieOptions.expires = options.maxAge / 86400; // convert seconds to days
  }

  Cookies.set(name, value, cookieOptions);
}

export function deleteClientCookie(name: string, path = "/") {
  Cookies.remove(name, { path });
}
